module.exports = __webpack_public_path__ + "img/31.8401dd47.jpg";